<template>
	<div class="stepper-wrapper">
		<div
			class="stepper-item "
			:class="(completed >= i) ? 'completed' : ''"
			v-for="(stp, i) in stepper_array" :key="i"
			>
			<div 
			class="step-counter pointer" :class="step_class(i)" 
			@click="()=>{if(click_fnc){clickMe(i)}}"
				>
				<span v-if="danger_icon(i)">
					<i class="fa" style="font-size: 7px;">&#xf00d;</i>
				</span>
				<span v-else-if="set_step_number(i)" style="font-size: 12px;">
					{{(i+1)}}
				</span>
				<span v-else>
					<i class="fa fa-check" style="font-size: 7px;"></i>
				</span>
			</div>
			<div class="step-name text-center" :class="stp_class(i)" style="font-size: 12px;">
				{{stp}}
			</div>
		</div>
	</div>
</template>

	<script>
		export default {
			name: 'progress_bar',
			data(){
				return {

				}
			},
			components: {

			},
			props: {
				completed: {
					default: 0,
				},
				stepper_array:{
					default: ['text1', 'text2', 'text3'] ,
				},
				stepper_warning:{
					default: [1] ,
				},
				stepper_danger:{
					default: [2] ,
				},
				click_fnc:{
					default: false
				}
			},
			mounted(){
			},
			methods:{
				set_step_number(i){
					return (this.completed <= i || this.stepper_danger.includes(i) || this.stepper_warning.includes(i));
				},
				// ********************************************************************
				clickMe(i){
					if(this.completed > i && !this.click_fnc){
						this.$emit('click', i);
					}
					if(this.click_fnc){
						this.$emit('click', i);
					}
				},
				// ********************************************************************
				stp_class(i){
					var class_text = "";
					if(i == this.completed){
						class_text = "font-weight-bold";
					} else if(i < this.completed) {
						class_text = "text-success";
					}else {
						class_text = "text-secondary";
					}
					if(this.stepper_warning.includes(i)){
						class_text = "text-orange";
					}
					if(this.stepper_danger.includes(i)){
						class_text = "text-danger";
					}
					return class_text;
				},
				// ********************************************************************
				step_class(i=0){
					var class_s = "";
					if(this.completed > i){
							class_s = "btn-success pointer";
					}
					if(this.stepper_warning.includes(i)){
						class_s = "btn-orange pointer";
					}
					if(this.stepper_danger.includes(i)){
						class_s = "btn-danger";
					}
					return class_s;
				},
				// ********************************************************************
				danger_icon(i){
					return this.stepper_danger.includes(i);
				},
			}
		}
	</script>
<style>
	.stepper-wrapper {
		margin-top: auto;
		display: flex;
		justify-content: space-between;
		margin-bottom: 20px;
	}
	.stepper-item {
		position: relative;
		display: flex;
		flex-direction: column;
		align-items: flex-start;
		flex: 1;
		@media (max-width: 768px) {
			font-size: 12px;
		}
	}
	.stepper-item::before {
		position: absolute;
		content: "";
		border-bottom: 2px solid #ccc;
		width: 100%;
		top: 10px;
		right: -100%;
		z-index: 2;
	}
	.stepper-item::after {
		position: absolute;
		content: "";
		border-bottom: 2px solid #ccc;
		width: 100%;
		top: 10px;
		right: 50%;
		z-index: 2;
	}
	.stepper-item .step-counter {
		position: relative;
		z-index: 5;
		display: flex;
		justify-content: center;
		align-items: center;
		width: 20px;
		height: 20px;
		border-radius: 50%;
		background: #fff;
		border: 2px solid #ccc;
		margin-bottom: 6px;
	}
	.stepper-item .step-counter {
		background-color: #fff;
		border: 2px solid rgb(33 147 128 / 50%);
	}
	.stepper-item::after {
		border-bottom: 2px solid rgb(33 147 128 / 50%);
		position: absolute;
		content: "";
		width: 100%;
		top: 10px;
		right: 0;
		z-index: 3;
	}
	.stepper-item:first-child::before {
		content: none;
	}
	.stepper-item:last-child::after {
		content: none;
	}
	.completed::after {
		border-bottom: 2px solid rgb(33 147 128 / 100%);
		position: absolute;
		content: "";
		width: 100%;
		top: 10px;
		right: 0;
		z-index: 3;
	}
	.completed .step-counter {
		background-color: #fff;
		border: 2px solid rgb(33 147 128 / 100%);
	}
</style>
